import React from 'react';
import { IButton } from './button.type';
import { ButtonWrapper, Loading } from './button.styles';

const Button: React.FC<IButton> = ({
  children,
  variant = 'primary',
  size = 'medium',
  fullWidth = false,
  rounded = false,
  disabled = false,
  loading = false,
  icon,
  iconPosition = 'left',
  type = 'button',
  onClick,
  ...props
}) => {
  return (
    <ButtonWrapper
      variant={variant}
      size={size}
      fullWidth={fullWidth}
      rounded={rounded}
      disabled={disabled || loading}
      onClick={onClick}
      type={type}
      {...props}
    >
      {loading ? (
        <Loading />
      ) : (
        <>
          {icon && iconPosition === 'left' && icon}
          {children}
          {icon && iconPosition === 'right' && icon}
        </>
      )}
    </ButtonWrapper>
  );
};

export default Button;
